import { useRouter } from 'next/router'
import Image from 'next/legacy/image'
import Skeleton from 'react-loading-skeleton'
import clsx from 'clsx'

import PreviewImage from './preview-image'
import LikesGet from 'components/parts/like-get/like-get'
import ViewsGet from 'components/parts/views-get/views-get'
import CommentsCountGet from 'components/parts/comments-count-get/comments-count-get'
import CardCategory from 'components/cards/card-parts/card-category/card-category'
import CardDuration from 'components/cards/card-parts/card-duration/card-duration'
import CardWatchStatus from '../card-parts/card-watch-status/card-watch-status'
import usePCWindow from 'hooks/usePCWindow'

import { formatPublicationDate } from 'components/cards/publication-card/utils'
import { getPreview } from './utils'
import { highlightText } from 'utils/search/hightlightText'
import { valueDate } from 'utils/formatDate'
import { ImageData } from 'components/cards/data'
import { INewslineCard } from 'constants/types/card.types'
import { TypeCodes } from 'constants/data'
import { ScreenSize } from 'constants/media-constanst'
import { A_clickNewsline } from 'utils/analytics/library/utils'

import styles from './newsline-card.module.scss'
import commonStyles from 'styles/common/cards.module.scss'

const NewslineCard = ({
  id,
  materialType,
  ArticleTypeId,
  startDate,
  previewName,
  videoLink,
  name,
  duration,
  descriptionShort,
  withPreview = true,
  cutQueryWords,
  modificator,
  watchStatus,
  alternativeDate,
  wrapModificator,
  modImgBox,
  modBottom,
  AData,
}: INewslineCard) => {
  const { basePath } = useRouter()

  const isMobile = usePCWindow(ScreenSize.mobile)

  const formatedPublicationDate = alternativeDate
    ? valueDate(String(startDate))
    : formatPublicationDate(startDate)
  const isArticle = ArticleTypeId === TypeCodes.ARTICLE
  const previewImgData = getPreview(
    basePath,
    previewName,
    videoLink,
    materialType,
    isMobile ? '700' : '1400'
  )

  const viewsPath = `/${materialType}/${id}`

  // const hightlightedTitle = highlightText(cutQueryWords, name)
  // const hightlightedDescription = highlightText(cutQueryWords, descriptionShort)

  return (
    <div
      className={clsx(styles.cardWrapper, {
        [wrapModificator as string]: wrapModificator,
      })}
      onClick={() => {
        AData && A_clickNewsline(AData.origin, id, materialType, ArticleTypeId)
      }}
    >
      <div className={styles.cardTop}>
        <CardCategory materialType={materialType} ArticleTypeId={ArticleTypeId} />
        <div className={styles.cardTopRight}>
          <CardWatchStatus status={watchStatus} ArticleTypeId={ArticleTypeId} />
        </div>
      </div>
      <div
        className={clsx(commonStyles.title, styles.title, {
          [styles.smallerMargin]: Boolean(descriptionShort),
          [modificator as string]: modificator,
        })}
        dangerouslySetInnerHTML={{ __html: name }}
      ></div>
      {descriptionShort && (
        <div className={clsx(styles.spoiler, commonStyles.subtitle)}>
          <span dangerouslySetInnerHTML={{ __html: descriptionShort }} />
        </div>
      )}
      <div className={clsx(styles.cardImgBox, { [modImgBox as string]: modImgBox })}>
        {withPreview && (
          <div className={styles.preview}>
            {name && (
              <PreviewImage
                {...previewImgData}
                className={styles.previewImg}
                width="100%"
                height="auto"
                // loading="lazy"
                alt="Превью материала"
              />
            )}
            {ArticleTypeId !== TypeCodes.CLINIC && (
              <div className={clsx(styles.messageOverImg)}>
                <CardDuration duration={duration} formatString={isArticle} />
              </div>
            )}
          </div>
        )}
      </div>

      <div className={clsx(styles.bottom, { [modBottom as string]: modBottom })}>
        <div className={styles.date}>{formatedPublicationDate || <Skeleton width={150} />}</div>
        <div className={styles.bottomRight}>
          <div className={styles.bottomRightPart}>
            <Image {...ImageData.views_grey} layout="fixed" />
            <span className={styles.count}>{name && <ViewsGet id={viewsPath} />}</span>
          </div>
          <div className={styles.bottomRightPart}>
            <Image {...ImageData.comment} layout="fixed" />
            <span className={styles.count}>
              {name && <CommentsCountGet materialId={id} materialType={materialType} />}
            </span>
          </div>
          <div className={styles.bottomRightPart}>
            <Image {...ImageData.like_grey} layout="fixed" />
            <span className={styles.count}>{name && <LikesGet id={viewsPath} />}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewslineCard
